<template>
  <div>
    <a-descriptions bordered size="small" title="" :column="3">
      <a-descriptions-item :label="item.name" v-for="item in detail">{{ item.vaules }}</a-descriptions-item>

    </a-descriptions>
  </div>
</template>

<script>
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: []
    }
  },
  methods: {
    initDetail (model) {
      if (model.fieldValueList) {
        for (const item of model.fieldValueList) {
          const data = {
            fieldId: item.fieldId,
            vaules: item.vaules,
            name: item.name
          }
          if (item.valueType === 2) {
            if (item.valueOptions) {
              data.selectList = item.valueOptions.split('、')
            }
          }
          this.detail.push(data)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
